import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';

const ApplicationsPage = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isMobile, setIsMobile] = useState(false);

  // Başvuruları yükle
  useEffect(() => {
    // Tarayıcı title'ını ayarla
    document.title = 'FBAJANS WhatsApp Business - Başvurular';
    
    // Check if mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    // Başvuruları yükle
    fetchApplications();
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const fetchApplications = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/admin/applications');
      const data = await response.json();
      
      if (data.success) {
        // Sadece bekleyen başvuruları al
        const pendingApplications = (data.data || []).filter(app => app.status === 'pending');
        setApplications(pendingApplications);
      } else {
        setError(data.message || 'Başvurular yüklenemedi');
      }
    } catch (error) {
      setError('Sunucu hatası');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (applicationId) => {
    try {
      const response = await fetch(`/api/admin/applications/${applicationId}/approve`, {
        method: 'POST'
      });
      const data = await response.json();
      
      if (data.success) {
        alert('Başvuru onaylandı ve firma oluşturuldu!');
        fetchApplications(); // Listeyi yenile
      } else {
        alert(data.message || 'Başvuru onaylanamadı');
      }
    } catch (error) {
      alert('Sunucu hatası');
    }
  };

  const handleReject = async (applicationId) => {
    if (!confirm('Bu başvuruyu reddetmek istediğinizden emin misiniz?')) {
      return;
    }

    try {
      const response = await fetch(`/api/admin/applications/${applicationId}/reject`, {
        method: 'POST'
      });
      const data = await response.json();
      
      if (data.success) {
        alert('Başvuru reddedildi!');
        fetchApplications(); // Listeyi yenile
      } else {
        alert(data.message || 'Başvuru reddedilemedi');
      }
    } catch (error) {
      alert('Sunucu hatası');
    }
  };

  const getStatusBadge = (status) => {
    const styles = {
      pending: { background: '#fef3c7', color: '#92400e', text: 'Bekliyor' },
      approved: { background: '#d1fae5', color: '#065f46', text: 'Onaylandı' },
      rejected: { background: '#fee2e2', color: '#991b1b', text: 'Reddedildi' }
    };
    
    const style = styles[status] || styles.pending;
    
    return (
      <span style={{
        padding: '4px 12px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: 'bold',
        background: style.background,
        color: style.color
      }}>
        {style.text}
      </span>
    );
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <div style={{ fontSize: '24px' }}>⏳</div>
        <div style={{ marginTop: '10px', color: '#666' }}>Başvurular yükleniyor...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <i className="fas fa-exclamation-circle" style={{ fontSize: '24px', color: '#e53e3e' }}></i>
        <div style={{ marginTop: '10px', color: '#e53e3e' }}>{error}</div>
        <button 
          onClick={fetchApplications}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            background: '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          Tekrar Dene
        </button>
      </div>
    );
  }

  return (
    <AdminLayout>
      <div style={{ padding: isMobile ? '15px' : '30px' }}>
        {/* Standart Header */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '30px',
          marginBottom: '30px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          border: '1px solid #e2e8f0'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '20px' : '0'
          }}>
            <div>
              <h1 style={{ 
                margin: '0 0 5px', 
                fontSize: isMobile ? '24px' : '32px', 
                fontWeight: '700',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                FBAJANS WhatsApp Business
              </h1>
              <p style={{ 
                margin: '0 0 5px', 
                fontSize: isMobile ? '16px' : '18px',
                fontWeight: '500',
                color: '#555'
              }}>
                <i className="fas fa-clipboard-list" style={{ marginRight: '8px' }}></i>
                Başvurular
              </p>
              <p style={{ 
                margin: '5px 0 0 0', 
                fontSize: isMobile ? '13px' : '14px',
                color: '#999'
              }}>
                Yeni firma başvurularını yönetin
              </p>
            </div>
            <div style={{
              display: 'flex',
              gap: '15px',
              flexWrap: 'wrap',
              justifyContent: isMobile ? 'center' : 'flex-end'
            }}>
              {/* Summary Info */}
              <div style={{
                background: '#f8f9fa',
                borderRadius: '20px',
                padding: '10px 20px',
                border: '1px solid #e2e8f0',
                fontSize: '14px',
                color: '#555',
                fontWeight: '500'
              }}>
                Toplam: {applications.length} Bekleyen: {applications.filter(app => app.status === 'pending').length}
              </div>
            </div>
          </div>
        </div>

      {/* Applications List */}
      {applications.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '60px 20px',
          background: '#f7fafc',
          borderRadius: '12px',
          border: '2px dashed #cbd5e0'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>📭</div>
          <h3 style={{ margin: 0, color: '#4a5568', fontSize: '20px' }}>
            Henüz başvuru bulunmuyor
          </h3>
          <p style={{ margin: '10px 0 0 0', color: '#718096' }}>
            Yeni başvurular burada görünecek
          </p>
        </div>
      ) : (
        <div style={{
          display: 'grid',
          gap: '20px',
          gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))'
        }}>
          {applications.map((application) => (
            <div key={application.id} style={{
              background: 'white',
              borderRadius: '12px',
              padding: '24px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
              border: '1px solid #e2e8f0',
              transition: 'all 0.2s ease'
            }}>
              {/* Header */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginBottom: '20px'
              }}>
                <div>
                  <h3 style={{
                    margin: 0,
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: '#2d3748'
                  }}>
                    {application.fullName}
                  </h3>
                  <p style={{
                    margin: '5px 0 0 0',
                    color: '#718096',
                    fontSize: '14px'
                  }}>
                    @{application.username}
                  </p>
                </div>
                {getStatusBadge(application.status)}
              </div>

              {/* Details */}
              <div style={{ marginBottom: '20px' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '8px',
                  fontSize: '14px'
                }}>
                  <span style={{ marginRight: '8px', fontSize: '16px' }}>📧</span>
                  <span style={{ color: '#4a5568' }}>{application.email}</span>
                </div>
                
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '8px',
                  fontSize: '14px'
                }}>
                  <i className="fas fa-mobile-alt" style={{ marginRight: '8px', fontSize: '16px' }}></i>
                  <span style={{ color: '#4a5568' }}>{application.whatsappNumber}</span>
                </div>
                
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '14px'
                }}>
                  <span style={{ marginRight: '8px', fontSize: '16px' }}>📅</span>
                  <span style={{ color: '#4a5568' }}>{formatDate(application.createdAt)}</span>
                </div>
              </div>

              {/* Actions */}
              {application.status === 'pending' && (
                <div style={{
                  display: 'flex',
                  gap: '10px',
                  marginTop: '20px'
                }}>
                  <button
                    onClick={() => handleApprove(application.id)}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'linear-gradient(135deg, #48bb78 0%, #38a169 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 4px 12px rgba(72, 187, 120, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    <i className="fas fa-check" style={{ marginRight: '8px' }}></i>
                    Onayla
                  </button>
                  
                  <button
                    onClick={() => handleReject(application.id)}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'linear-gradient(135deg, #f56565 0%, #e53e3e 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 4px 12px rgba(245, 101, 101, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    <i className="fas fa-times" style={{ marginRight: '8px' }}></i>
                    Reddet
                  </button>
                </div>
              )}

              {/* Approved/Rejected Info */}
              {application.status !== 'pending' && (
                <div style={{
                  padding: '12px',
                  background: application.status === 'approved' ? '#f0fff4' : '#fef2f2',
                  borderRadius: '8px',
                  border: `1px solid ${application.status === 'approved' ? '#9ae6b4' : '#fecaca'}`,
                  fontSize: '14px',
                  color: application.status === 'approved' ? '#22543d' : '#742a2a'
                }}>
                  {application.status === 'approved' ? <i className="fas fa-check-circle" style={{ marginRight: '8px', color: '#28a745' }}></i> : <i className="fas fa-times-circle" style={{ marginRight: '8px', color: '#dc3545' }}></i>}
                  {application.status === 'approved' ? 'Onaylandı' : 'Reddedildi'} - 
                  {formatDate(application.approvedAt)}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      </div>
    </AdminLayout>
  );
};

export default ApplicationsPage;
